// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import App from './App'
import router from './router/index.js'
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import axios from 'axios'// 引入axios
import Vant from 'vant'
import 'vant/lib/index.css'
import VCharts from 'v-charts'
import store from './store'
import common from './common/index.js'
import request from './common/request.js'
import VueClipboard from 'vue-clipboard2'

import 'lib-flexible/flexible.js'
import './assets/base.css'
import './assets/iconfont/iconfont.css'

// const Vue = require('vue')
// const Vant = require('vant')
// const VCharts = require('v-charts')
// const ElementUI = require('element-ui')
// const axios = require('axios')
import { Dialog } from 'vant'
import { Toast } from 'vant'
import { ImagePreview } from 'vant'

// 全局注册
Vue.use(Dialog)
Vue.use(Toast)
Vue.use(ImagePreview)
Vue.use(Vant)
Vue.use(VCharts)
Vue.use(ElementUI)
Vue.use(VueClipboard)
// Vue.use(common)

Vue.config.productionTip = false
Vue.prototype.common = common
Vue.prototype.$axios = request

/** 获取本链接上面的参数param参数的名称 */
Vue.prototype.getUrlParam = function (param) {
  return this.$route.query[param]
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js